import { ISortOrder } from '../sort-toggle/sort-toggle.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { Account } from '../data/account';
import { Student } from '../data/student';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css']
})
export class StudentsComponent extends BaseComponent implements OnInit {
  searchValue: string = '';
  selectedSort: ISortOrder = { orderBy: "ID", ascending: false };

  ngOnInit() {
    this.allListItems = [];
    this.listItems$ = of(this.allListItems);
    this.searching = false;
  }

  getStudents(sortOrder: ISortOrder): void {
    if (sortOrder)
        this.selectedSort = { orderBy: sortOrder.orderBy, ascending: sortOrder.ascending };
    else
        this.selectedSort = { orderBy: "ID", ascending: false }
    this.searching = true;
    this.dataService.getStudents(this.selectedSort.ascending, undefined, this.searchValue)
      .subscribe(students => {
        this.allListItems = students;
        this.listItems$ = of(students);
        this.searching = false;
      });
  }

  getRouterLink(student: Student) {
    return `/studnets/${student.ID}`;
  }

  navTo(student: Student) {
    this.goToRoute(student, `/students/${student.ID}`, null);
  }

  performSearch(term): Observable<any> {
    return this.dataService.getStudents(this.selectedSort.ascending, undefined, term);
  }
}
